<template>
  <div style="background-color:white;height: 100%;width: 100%;">
    <el-row>
      <el-col :span="12">
        <div>
          <el-table @row-click="transfer" :data="tableData" highlight-current-row style="width: 100%;" :border="true"
            ref="multipleTable" tooltip-effect="dark" stripe
            :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }" :cell-style="{ textAlign: 'center' }">
            <el-table-column prop="departmentCode" label="部门编号">
            </el-table-column>
            <el-table-column prop="departmentName" label="部门名称">
            </el-table-column>
            <el-table-column prop="companyName" label="所属单位">
            </el-table-column>
            <el-table-column prop="id" v-if="false" label="部门id">
            </el-table-column>
          </el-table>
          <!--分页工具条-->
          <el-col :span="24" class="toolbar" style="margin-top:5px;height: 35px;">
            <el-pagination v-if="tableData.length > 0" @size-change="handleSizeChange"
              @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100]" :page-size="pagesize"
              layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:right">
            </el-pagination>
          </el-col>
        </div>
      </el-col>
      <el-col :span="12">
        <div style="margin-top:50px;margin-left:50px;">
          <el-form label-width="80px" :model="form">
            <el-form-item label="所属机构">
              <el-select style="width: 100%" v-model.trim="form.companyCode" clearable placeholder="请选择单位"
                @change="selectByIdDepartment">
                <el-option v-for="item in options" :key="item.companyCode" :label="item.companyName"
                  :value="item.companyCode">
                </el-option> </el-select>
            </el-form-item>
            <el-form-item label="部门名称">
              <el-input v-model.trim="form.departmentName"></el-input>
            </el-form-item>
            <el-button  v-preventReClick type="primary" @click="handleCreate"
              icon="el-icon-plus">增加</el-button>
            <el-button  v-preventReClick type="primary" @click="handleCreate1"
              icon="el-icon-edit">修改</el-button>
            <el-button  v-preventReClick type="danger" @click="handleCreate2"
              icon="el-icon-delete">删除</el-button>
          </el-form>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {
  selectAllDepartment,
  selectAllCompany,
  selectByIdDepartment,
  addDepartment,
  updateDepartment,
  delDepartment
} from "../../api/api";
export default {
  name: "Department",
  data() {
    return {
      total: 0,
      pageIndex: 1,
      pagesize: 10,
      data: [],
      options: [],
      multipleTable: [],
      form: {
        companyCode: "",
        departmentName: ""
      },
      tableData: [],
      questionForm: {
        name: ""
      }
    };
  },
  methods: {
    transfer(row) {
      this.form.departmentCode = row.departmentCode
      this.form.companyCode = row.companyCode;
      this.form.departmentName = row.departmentName;
    },
    //增加部门信息
    handleCreate() {
      addDepartment(this.form).then(datas => {
        let { status, message } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error"
          });
        } else if (status == 200) {
          this.$message({
            message: "添加成功",
            type: "success"
          });
          this.selectDepartment();
        } else {
          this.$message({
            message: "请求错误",
            type: "error"
          });
        }
      });
    },
    //修改部门信息
    handleCreate1() {
      updateDepartment(this.form).then(datas => {
        let { status, message } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error"
          });
        } else if (status == 200) {
          this.selectDepartment();
          this.$message({
            message: "修改成功",
            type: "success"
          });
        } else {
          this.$message({
            message: "请求错误",
            type: "error"
          });
        }
      });
    },
    //删除部门信息
    handleCreate2() {
      this.$confirm('此操作将永久删除该部门, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delDepartment(this.form.departmentCode).then(datas => {
          let { status, message } = datas;
          if (status == 400) {
            this.$message({
              message: message,
              type: "error"
            });
          } else if (status == 200) {
            this.selectDepartment();
            this.form.departmentName = "";
            this.$message({
              message: "删除成功",
              type: "success"
            });
          } else {
            this.$message({
              message: "请求错误",
              type: "error"
            });
          }
        });
      })
    },
    selectByIdDepartment() {
      selectByIdDepartment(this.form.companyCode).then(datas => {
        let { status, message, data } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error"
          });
        } else if (status == 200) {
          this.data = data;
          this.tableData = this.data.slice((this.pageIndex - 1) * this.pagesize, this.pageIndex * this.pagesize)
          this.total = data.length;
        } else {
          this.$message({
            message: "请求错误",
            type: "error"
          });
        }
      });
    },
    selectCompany() {
      selectAllCompany().then(datas => {
        let { status, message, data } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error"
          });
        } else if (status == 200) {
          this.options = data;
        } else {
          this.$message({
            message: "请求错误",
            type: "error"
          });
        }
      });
    },
    selectDepartment() {
      selectAllDepartment().then(datas => {
        let { status, message, data } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error"
          });
        } else if (status == 200) {
          this.data = data;
          this.tableData = this.data.slice((this.pageIndex - 1) * this.pagesize, this.pageIndex * this.pagesize)
          this.total = data.length;
        } else {
          this.$message({
            message: "请求错误",
            type: "error"
          });
        }
      });
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      //contentdata是所有的数据，是一个大数组。使用.slice()方法可以将大数组切分
      //.slice()方法接受两个参数，开始和结束的值
      //这样得到的currentdata就是固定只有10个值的数组了，就可以用v-for展示啦
      this.tableData = this.data.slice(
        (this.pageIndex - 1) * this.pagesize,
        this.pageIndex * this.pagesize
      );
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.tableData = this.data.slice(
        (this.pageIndex - 1) * this.pagesize,
        this.pageIndex * this.pagesize
      );
    }
  },
  created() {
    this.selectDepartment();
    this.selectCompany();

  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/views/SystemSettings/Department.vue